<h3 translate class="page-title text-center">SAVED_QUOTES</h3>
<lib-filter-list #productList [configService]="savedQuoteConfigService"></lib-filter-list>
